import { createSelector } from 'reselect';

import { periodSelector } from '../../../reducers/selectors';

const isFirstPeriodSelector = createSelector(periodSelector, period => period.periodOrder === 1);

export default isFirstPeriodSelector;
